export const SUBSCRIPTION_PUSH_PLAN_DETAILS = 'SUBSCRIPTION_PUSH_PLAN_DETAILS';
export const SUBSCRIPTION_PUSH_ADD_ON_DETAILS = 'SUBSCRIPTION_PUSH_ADD_ON_DETAILS';
export const SUBSCRIPTION_RESET = 'SUBSCRIPTION_RESET';

export const subscriptionPushPlanDetails = (payload) => ({
  type: SUBSCRIPTION_PUSH_PLAN_DETAILS,
  payload,
});

export const subscriptionPushAddOnDetails = (payload) => ({
  type: SUBSCRIPTION_PUSH_ADD_ON_DETAILS,
  payload,
});

export const subscriptionResetDetails = (defaultR = {}) => ({
  type: SUBSCRIPTION_RESET,
  payload: defaultR,
});
